import React from "react";
import { func, bool, string, PropTypes } from "prop-types";

import "./detailsModal.css";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import CustomCloseModalButton from "../../common/CustomCloseModalButton";

const DetailsModal = ({
  isOpen,
  toggle,
  modalHeader,
  modalBody,
  size,
  url,
}) => (
  <React.Fragment>
    <Modal style={{ top: 0 }} isOpen={isOpen} size={size}>
      <ModalHeader close={<CustomCloseModalButton toggle={toggle} />}>
        <a href={url} target="_blank">
          {modalHeader}
        </a>
      </ModalHeader>
      <ModalBody style={{ maxHeight: 450 }} className="modal-body">
        <pre>{modalBody}</pre>
      </ModalBody>
      <ModalFooter>
        <Button
          className="details-modal-button confirm-button"
          color="primary"
          onClick={toggle}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  </React.Fragment>
);

DetailsModal.propTypes = {
  isOpen: bool.isRequired,
  toggle: func.isRequired,
  modalHeader: string.isRequired,
  modalBody: PropTypes.any,
  size: string,
};

export default DetailsModal;



// WEBPACK FOOTER //
// ./src/components/modals/details-modal/DetailsModal.jsx